import { useHistory } from 'react-router-dom'

import ORNALogo from 'src/assets/ORNA Square Logo, transparent bg.png'
import withSentryWrapper from 'src/components/common/withSentryWrapper'

const MobileScreen = () => {
    const height = window.outerHeight
    const history = useHistory()
    return (
        <div style={{ height: height }}>
            <div className="flex h-full w-full items-center">
                <div>
                    <img
                        className="mx-auto"
                        src={ORNALogo}
                        width={200}
                        height={200}
                    />
                    <div className="mt-8">
                        <div className="text-center text-3xl text-white">
                            MOBILE COMING SOON
                        </div>
                        <div className="mt-8 px-10 text-center text-lg text-neutral-gray-75">
                            The team is working hard on getting ORNA's mobile
                            version to you ASAP.
                        </div>
                        <div className="mt-8 px-10 text-center text-lg text-primary-red">
                            In the meantime, please use ORNA on your laptop or
                            desktop.
                        </div>
                        <div className="mt-8 flex w-full items-center justify-center px-6">
                            <button
                                className="w-64 rounded bg-primary-red-500 px-4 py-3 text-center font-Arial text-12-14 font-medium text-white"
                                onClick={() => {
                                    history.push('/signup')
                                }}
                            >
                                SIGN UP FOR FREE
                            </button>
                        </div>
                        <div className="mt-8 flex w-full items-center justify-center px-6">
                            <button
                                className="bg-secondary-red-500 w-64 rounded px-4 py-3 text-center font-Arial text-12-14 font-medium text-white"
                                onClick={() => {
                                    window.open('https://www.orna.app/')
                                }}
                            >
                                BACK TO ORNA WEBSITE
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withSentryWrapper(MobileScreen)
